import React, {useEffect, useState} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Container, Row, Col, Card, CardBody, CardTitle, CardSubtitle, Table } from "reactstrap";

import Breadcrumbs from "../../components/Common/Breadcrumb";
import * as url from "../../helpers/url_helper"
import axios from 'axios';
import { formatDate, HRConfig } from '../../helpers/backend_helper';


    const DisciplinarySetup = () => {
        const [gActions, setGActions] = useState([])
        const [gTypes, setGTypes] = useState([])
        useEffect(()=>{
            axios.get(url.GRIEVANCE_TYPES, HRConfig).then((r)=>{ 
                setGTypes(r.data.value)
            }).catch((e)=>{ console.log(e) })
            axios.get(url.GRIEVANCE_ACTIONS, HRConfig).then((r)=>{ 
                console.log(r.data.value)
            }).catch((e)=>{ console.log(e) })
        },[])
        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>D&G Setup | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Setup" />
                        <Row>
                        <Col xl={12}>
                            <Card>
                                <CardBody>
                                <CardTitle>Disciplinary and Grievance Types</CardTitle>
                               

                                <div className="table-responsive">
                                    <Table className="table table-striped mb-0">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Code</th>
                                            <th>Type</th>
                                            <th>Category</th>
                                            <th>Description</th>
                                            <th style={{width:'50%'}}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {gTypes.map((t,k)=>(
                                        <tr key={k}>
                                            <th scope="row">{k+1}</th>
                                            <td>{t.Code}</td>
                                            <td>{t.Type}</td>
                                            <td>{t.DesciplinaryCategory}</td>
                                            <td>{t.Description}</td>
                                            <td>
                                            <i className="mdi mdi-chevron-right me-1"></i> <strong>First Offence: {'\t'}</strong>{t.FirstOffence}<br/>
                                            {(t.FirstOffence != "Dismissal") && (
                                                <>
                                                <i className="mdi mdi-chevron-right me-1"></i> <strong>Second Offence: </strong>{t.SecondOffence}<br/>
                                                {(t.SecondOffence != "Dismissal") && (
                                                    <>
                                                    <i className="mdi mdi-chevron-right me-1"></i> <strong>Third Offence: </strong>{t.ThirdOffence}<br/>
                                                    <i className="mdi mdi-chevron-right me-1"></i> <strong>Fourth Offence: </strong>{t.FourthOffence}
                                                    </>
                                                )}

                                                </>
                                            )}
                                            </td>
                                        </tr>
                                    ))}   
                                    </tbody>
                                    </Table>
                                </div>
                                </CardBody>
                            </Card>
                            </Col>
                        </Row>
                           

                    </Container>
                </div>
            </>
        );
    }

export default DisciplinarySetup;